export const SEND_MONEY_STEPS = {
  LOADING: 'LOADING',
  ENROLL_ERROR: 'ENROLL_ERROR',
  INTRO: 'INTRO',
  ACCOUNTS: 'ACCOUNTS',
  AMOUNT: 'AMOUNT',
  REVIEW: 'REVIEW',
  SUCCESS: 'SUCCESS',
};
export const STYLE = {
  PAGES: {
    INDEX: {
      APP_LAYOUT: {
        LAYOUT:
          'bg-bw02 h-screen pl-[10rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col',
        TITLE: 'font-metricMedium text-xl',
        NEW_LAYOUT:
          'bg-bw02 flex flex-col tab-landscape:pl-[112px] pc-sm:pl-[320px] pt-[46px] pb-20 fadeIn tab-landscape:w-[calc(100%-34px)] pc-sm:w-[calc(100%-34px)] height-[100vh]',
        NEW_TITLE: 'font-metricRMedium text-xl text-bw08 leading-7',
      },
      MAIN_CONTENT: 'relative flex flex-col bg-bw00 rounded-lg w-full min-h-[670px]',
      MAIN_CONTENT_NEW: 'relative flex flex-col pt-[40px] pl-[40px] pr-[40px] pb-[14px] bg-bw00 rounded-lg w-[456px]',
      SUB_CONTENT: 'flex flex-col relative p-[40px] bg-bw00 rounded-lg w-[360px] max-h-[65.6vh] min-h-[548px]',
      SUB_CONTENT_NEW: 'flex flex-col relative bg-bw00 rounded-lg p-[40px] w-[360px] max-h-[65.6vh]',
    },
    POST_LINKED: {
      HEADING: 'font-metricMedium text-[25px] text-bw08 mb-[16px]',
      CONTENT: 'text-sm font-metric text-bw07 mb-[40px]',
      LIST_HEADING_CTA_WRAPPER: 'flex justify-between w-full mb-[16px]',
      LIST_HEADING: 'font-metricMedium text-[16px] text-bw07',
      LIST_CTA: 'font-metric text-[13px] text-bw05',
      LIST_WRAPPER:
        'flex flex-col w-full rounded-md border-solid border-[1px] border-bw03 mb-[16px] max-h-[384px] overflow-auto animate-fadeIn',
      LINK_ITEM: {
        WRAPPER_BASE: 'flex px-4 py-4 cursor-pointer',
        WRAPPER_SELECTED: 'bg-action03 bg-opacity-20',
        WRAPPER_BORDER_BOTTOM: 'border-b-[1px] border-b-bw03',
        CONTENT_WRAPPER: 'flex flex-col',
        REMOVE_ICON: 'w-[20px] mr-4',
        HEADING: 'font-metricMedium text-base text-action03 mb-1.5',
        CONTENT: 'text-xs font-metric text-bw07',
      },
      PLAID_CTA: 'text-sm text-action03 font-metricMedium self-baseline',
    },
  },
};

export const TEXT = {
  PAGES: {
    INDEX: {
      LAYOUT: {
        HEADER: 'ADD_MONEY_LAYOUT_HEADER',
        HEADER_SEND_MONEY: 'SEND_MONEY_LAYOUT_HEADER',
      },
    },
    POST_LINKED: {
      HEADING: 'ADD_MONEY_GET_POST_LINK_HEADING',
      HEADING_SEND: 'SEND_MONEY_GET_POST_LINK_HEADING',
      CONTENT: 'ADD_MONEY_GET_POST_LINK_CONTENT',
      CONTENT_SEND: 'SEND_MONEY_GET_POST_LINK_CONTENT',
      SUB_HEADER: 'ADD_MONEY_GET_POST_LINK_SUB_HEADER',
      EDIT_ACCOUNTS_LIST_CTA_MODE_A: 'ADD_MONEY_GET_POST_LINK_EDIT_LIST_MODE_A',
      EDIT_ACCOUNTS_LIST_CTA_MODE_B: 'ADD_MONEY_GET_POST_LINK_EDIT_LIST_MODE_B',
      PLAID_CTA: 'ADD_MONEY_POST_LINK_PLAID_CTA',
      MONEY_TRANSFER: {
        HEAD: {
          HEADING: 'ADD_MONEY_TRANSFER_MONEY_HEAD_HEADING',
        },
        BODY: {
          HEADING: 'ADD_MONEY_TRANSFER_MONEY_BODY_HEADING',
          BALANCE_CONTENT: 'ADD_MONEY_TRANSFER_MONEY_BODY_BALANCE_CONTENT',
          BALANCE_LINE_1: 'ADD_MONEY_TRANSFER_BODY_BALANCE_LINE_1',
          BALANCE_LINE_2: 'ADD_MONEY_TRANSFER_BODY_BALANCE_LINE_2',
          MAX_TRANSFER: 'ADD_MONEY_FLOW_TRANSFER_AMOUNT_ERROR',
          MAX_TRANSFER_CHECKING_ACCOUNT: 'ADD_MONEY_FLOW_TRANSFER_AMOUNT_CHECKING_ERROR',
        },
        FOOTER: {
          CTA_TITLE: 'ADD_MONEY_TRANSFER_MONEY_FOOTER_CTA_TITLE',
          CONTENT: 'ADD_MONEY_TRANSFER_MONEY_FOOTER_CONTENT',
        },
        USER_MESSAGE: {
          MAIN_HEADING: 'ADD_MONEY_TRANSFER_MONEY_UM_MAIN_HEADING',
          DISCLAIMER: 'ADD_MONEY_TRANSFER_MONEY_UM_DISCLAIMER',
          DISCLAIMER_REPLACE_PARAM: 'INSTITUTION_NAME',
          AMOUNT: 'ADD_MONEY_TRANSFER_MONEY_UM_DETAILS_ITEM_1',
          FROM: 'ADD_MONEY_TRANSFER_MONEY_UM_DETAILS_ITEM_2',
          TO: 'ADD_MONEY_TRANSFER_MONEY_UM_DETAILS_ITEM_3',
          ESTIMATE: 'ADD_MONEY_TRANSFER_MONEY_UM_DETAILS_ITEM_4',
          CHECKING_ACCOUNT: 'ADD_MONEY_TRANSFER_MONEY_UM_DETAILS_ITEM_5',
          CTA_CANCEL: 'ADD_MONEY_TRANSFER_MONEY_UM_ACTION_CANCEL',
          CTA_CONFIRM: 'ADD_MONEY_TRANSFER_MONEY_UM_ACTION_CONFIRM',
        },
      },
    },
  },
} as const;

export const WIZARD_MODE_STEPS = [SEND_MONEY_STEPS.AMOUNT, SEND_MONEY_STEPS.REVIEW, SEND_MONEY_STEPS.SUCCESS];
